import { AlertCircle } from 'lucide-react';

/**
 * Error placeholder with a retry button.
 *
 * Props:
 *   message?: string — defaults to a generic copy
 *   onRetry?: () => void
 *   compact?: boolean
 */
export function NotificationErrorState({
  message = "We couldn't load notifications.",
  onRetry,
  compact = false,
}) {
  const padding = compact ? 'px-4 py-6' : 'px-4 py-10';
  return (
    <div className={`flex flex-col items-center justify-center text-center ${padding}`} role="alert">
      <span className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-red-50">
        <AlertCircle className="h-5 w-5 text-red-500" />
      </span>
      <p className="text-sm font-medium text-gray-800">{message}</p>
      <p className="mt-1 text-xs text-gray-500">Check your connection and try again.</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-3 rounded-md border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50"
        >
          Retry
        </button>
      )}
    </div>
  );
}
